import React, {useEffect, useState} from "react";
import Moment from 'react-moment';
//import Grid from "../../components/Grid/Grid";
import { Table, Button, message, Upload } from "antd";
import { ManageCsvFileApiService } from '../../api/ManageCsvFileApi.service';
import {useSelector, useDispatch} from 'react-redux'
import {update} from "../../reducers/paginationSlice";
import {updateSort} from "../../reducers/sortSlice";
import "antd/dist/antd.css";
import { withRouter } from "react-router-dom";

import './ManageCsvFile.scss';
import { useTranslation } from "react-i18next";

function ManageCsvFile(props) {
    const {t} = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [csvFiles, setCsvFiles] = useState([]);
    const [searchParams] = useState('');
    const dispatch = useDispatch()
    const pagination = useSelector((x) => x.csvfilelist.pagination['MANAGE_CSV_FILE']);
    const sort = useSelector((x) => x.csvfilelist.sort['MANAGE_CSV_FILE']);

    const columns = [
        {
            title: t('list.fileName'),
            dataIndex: 'fileName',
            key: 'fileName',
            sorter: true,
            sortOrder: undefined,
            width: 300
        },
        {
            title: t('list.creationDate'),
            dataIndex: 'creationDate',
            sorter: true,
            sortOrder: undefined,
            render: date => (
                <Moment format="DD-MM-yyyy HH:mm">
                    {date}
                </Moment>
            ),
            width: 200
        },
        {
            title: t('list.actions'),
            render: (a, record) => renderActionsColumn(a, record),
            width: 100
        }
    ];

    if (sort) {
        const sortedColumn = columns.filter(x => x.dataIndex === sort.column)[0];

        if (sortedColumn) {
            sortedColumn.sortOrder = sort.order;
        }
    }

    useEffect(() => {
        loadCvsFiles(
            pagination.current,
            sort.column,
            sort.order,
            searchParams);
    }, []);

    const renderActionsColumn = function (a, record) {
        return (<div>
            <Button className="action-button-download"
                onClick={() => handleDownloadButtonClick(`${record.id}`, `${record.fileName}`)}
                title={t('list.downloadCsvExplanation') + `: ${record.fileName}`}>
                {t('common.download')}
            </Button>
            <Button className="action-button-delete" type="danger"
                onClick={() => handleDeleteButtonClick(`${record.id}`,`${record.fileName}`)}
                title={t('list.deleteCsvExplanation') + `: ${record.fileName}`}>
                {t('list.delete')}
            </Button>
        </div>)
    }

    const loadCvsFiles = function (page, sortField, sortOrder, searchParams) {
        setIsLoading(true);

        if (sortOrder === undefined || sortField === undefined) {
            sortField = undefined;
            sortOrder = undefined;
        }

        return ManageCsvFileApiService
            .getPaginatedPatientCsvFiles(page, pagination.pageSize, sortField, sortOrder, searchParams)
            .then(
                csvFiles => {
                    setCsvFiles(csvFiles.data);
                    setIsLoading(false);

                    dispatch(update({
                        MANAGE_CSV_FILE: {
                            current: page,
                            pageSize: pagination.pageSize,
                            total: csvFiles.totalElements,
                            position: 'both'
                        }
                    }));

                    dispatch(updateSort({
                        MANAGE_CSV_FILE: {
                            column: sortField,
                            order: sortOrder
                        }
                    }));
                },
                () => {
                    setIsLoading(false);
                }
            );
    }

    const handleDownloadButtonClick = (fileId, fileName) => {
        ManageCsvFileApiService.downloadFile(fileId)
                .then(
                    (result) => {
                        const url = URL.createObjectURL(new Blob([result.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                    }
                ).catch(() => {
                    message.error('Failed to download file');
                });
    }

    const handleDeleteButtonClick = (fileId, fileName) => {

        if(window.confirm('Delete file: ' + fileName +'?')){
            ManageCsvFileApiService.deleteFile(fileId)
                .then(
                    (result) => {
                        loadCvsFiles(
                            pagination.current,
                            sort.column,
                            sort.order,
                            searchParams);
                    }
                ).catch(() => {
                    message.error('Failed to delete file');
                });
        }
    }

    const handleTableChange = (pagination, filters, sorter) => {
        loadCvsFiles(pagination.current, sorter.columnKey, sorter.order, searchParams)
    };

    const beforeUpload = function (fileToUpload) {
        setIsLoading(true);

        const isCsv = fileToUpload.type === 'text/csv' || fileToUpload.type === 'application/vnd.ms-excel';
        if (!isCsv) {
            message.error('You can only upload CSV file!');
            setIsLoading(false);
            return false;
        }
        const isLt5M = fileToUpload.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            message.error('File must smaller than 5MB!');
            setIsLoading(false);
            return false;
        }

        ManageCsvFileApiService.uploadFile(fileToUpload)
            .then(
                (result) => {
                    setIsLoading(false);
                    loadCvsFiles(
                                pagination.current,
                                sort.column,
                                sort.order,
                                searchParams);
                })
            .catch(() => {
                message.error('Failed to upload file');
            })
            .finally(() => {

            });

        return false;
    }

    return (
        <section className="manual-csv-file-page">
            <div className="form upload-form">
                <div className="file-uploads">
                    <Upload accept="text/csv" name="CSV-file"
                        beforeUpload={beforeUpload} showUploadList={false}>
                        <Button disabled={isLoading} loading={isLoading}>
                            {t("upload.selectFile")}
                        </Button>
                    </Upload>
                </div>
            </div>
            <div className="csv-file-list">
            			<Table
            				pagination={pagination}
            				loading={isLoading}
            				dataSource={csvFiles}
            				onChange={handleTableChange}
            				columns={columns}
            				rowKey="id"/>
            </div>
        </section>
    )
}

export default withRouter(ManageCsvFile);
